import React, { useEffect, useState } from "react";
import Shell from "@/components/Shell";
import EmptyState from "@/components/EmptyState";
import { api, formatApiErrorDetail } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";
import { Plus, Building2 } from "lucide-react";
import { toast } from "sonner";

export default function Companies() {
  const [items, setItems] = useState([]);
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState({ name: "", domain: "", industry: "", size: "" });

  const load = async () => { const { data } = await api.get("/companies"); setItems(data); };
  useEffect(() => { load(); }, []);

  const submit = async (e) => {
    e.preventDefault();
    try {
      await api.post("/companies", form);
      toast.success("Company created");
      setForm({ name: "", domain: "", industry: "", size: "" });
      setOpen(false);
      load();
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    }
  };

  return (
    <Shell title="Companies" actions={
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogTrigger asChild><Button size="sm" data-testid="btn-new-company"><Plus className="w-4 h-4 mr-2" />New company</Button></DialogTrigger>
        <DialogContent>
          <DialogHeader><DialogTitle>New company</DialogTitle></DialogHeader>
          <form onSubmit={submit} className="space-y-3">
            <div className="space-y-2"><Label>Name</Label><Input data-testid="company-name" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} required /></div>
            <div className="grid grid-cols-2 gap-3">
              <div className="space-y-2"><Label>Domain</Label><Input data-testid="company-domain" value={form.domain} onChange={(e) => setForm({ ...form, domain: e.target.value })} /></div>
              <div className="space-y-2"><Label>Industry</Label><Input data-testid="company-industry" value={form.industry} onChange={(e) => setForm({ ...form, industry: e.target.value })} /></div>
            </div>
            <div className="space-y-2"><Label>Size</Label><Input data-testid="company-size" value={form.size} onChange={(e) => setForm({ ...form, size: e.target.value })} placeholder="e.g. 11-50" /></div>
            <Button type="submit" data-testid="company-submit" className="w-full">Create</Button>
          </form>
        </DialogContent>
      </Dialog>
    }>
      <div className="p-6">
        <div className="border border-border rounded-md overflow-hidden">
          <table className="cf-table w-full text-sm">
            <thead>
              <tr>
                <th className="text-left py-2 px-3 font-medium">Name</th>
                <th className="text-left py-2 px-3 font-medium">Domain</th>
                <th className="text-left py-2 px-3 font-medium">Industry</th>
                <th className="text-left py-2 px-3 font-medium">Size</th>
              </tr>
            </thead>
            <tbody>
              {items.map((c) => (
                <tr key={c.id} data-testid={`company-row-${c.id}`}>
                  <td className="py-2 px-3 font-medium">{c.name}</td>
                  <td className="py-2 px-3 mono text-xs text-muted-foreground">{c.domain}</td>
                  <td className="py-2 px-3">{c.industry}</td>
                  <td className="py-2 px-3 text-muted-foreground">{c.size}</td>
                </tr>
              ))}
              {items.length === 0 && <tr><td colSpan={4} className="p-4"><EmptyState icon={Building2} title="No companies yet" hint="Companies are created automatically when you import contacts or discover businesses." /></td></tr>}
            </tbody>
          </table>
        </div>
      </div>
    </Shell>
  );
}
